import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { installApiFetchPatch } from './utils/api';
import { syncActiveCaisseYearWithCalendar } from './utils/caisseActiveYear';
import './index.css';
import './app-mobile.css';
import App from './App';

installApiFetchPatch();
syncActiveCaisseYearWithCalendar();
// Détecte le passage d'année même si l'onglet reste ouvert (test horloge PC)
setInterval(() => {
  syncActiveCaisseYearWithCalendar();
}, 60 * 1000);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);


